import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

//@Injectable({
//  providedIn: 'root'
//})
@Injectable()
export class IdentityService {

  private baseUrl = "api/Base/";

  userguid: string = "";

  constructor(private http: HttpClient) { }

  get(): string {
    return this.userguid;
  }

  update(_userguid: string): void {
    this.userguid = _userguid;
  }

  setUserGuid(): Observable<any> {
    var userguid = this.get().toString();
    return this.http.get<any>(this.baseUrl + "SetUserGuid?userguid=" + userguid).pipe();
  }

  getUserGuid(): Observable<string> {
    return this.http.get<string>(this.baseUrl + "GetUserGuid").pipe();
  }

  getCaseManagerInfo(): Observable<any> {
      return this.http.get<any>(this.baseUrl + "GetCaseManagerInfo").pipe();
  }
}
